import CustomToast from './CustomToast';
import type { CustomToastProps, ToastDescription } from './CustomToast';
import { getErrorResponsePayload } from '../utils/ajax';
import { getErrorToastDefaults } from '../utils/errorToastDefaults';

export interface ErrorToastProps
  extends Omit<CustomToastProps, 'status' | 'title' | 'description'> {
  error: unknown;
  title?: string;
  description?: ToastDescription;
}

const ErrorToast = ({
  error,
  title,
  description,
  ...rest
}: ErrorToastProps) => {
  const { code, message } = getErrorResponsePayload(error);
  const defaults = getErrorToastDefaults(code);

  return (
    <CustomToast
      status="error"
      title={title ?? message ?? defaults.title}
      description={description ?? defaults.description}
      {...rest}
    />
  );
};

export default ErrorToast;
